/* import __COLOCATED_TEMPLATE__ from './pop-down-menu.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();